import {
	ITranscriptSpeaker,
	ITranscriptUtterance,
	TranscriptRequestOptions,
} from '@api';
import { GUID, Guid_Empty } from '@common';

import {
	makeShortTimespan,
	makeFullTimespan,
} from './dateUtils';

interface ConvertedDialogueAct {
	// LATER: тут слишком много лишней инфы, сделать одну дату и убрать отсюда isPlaying, либо вообще убрать ConvertedDialogueAct
	initialData: IMeetingUtt,
	data: {
		id?: string,
		timeEndTicks: number,
		timeTicks: number,
		startTime: string,
		time: string,
		name: string,
		speakerId: string,
		text: string,
		textRe?: RegExp,
		nameRes?: RegExp[],
	},
	isPlaying: boolean,
	isHighlighted: boolean,
}

export interface IMeetingUtt extends ITranscriptUtterance {
	speaker?: ITranscriptSpeaker;
}

export const ProcessTranscript = (transcript: IMeetingUtt[], options: TranscriptRequestOptions): IMeetingUtt[] => {
	const punctuationChars = [ '.', ',', '?', '!', ';', ':' ];

	const result: IMeetingUtt[] = []
	let currentUtt: IMeetingUtt = null;
	let lastTraversedUtt: IMeetingUtt = null;

	if (!options.mergeUtts) {
		if (!options.reconstructUtts) {
			// Not Merge, Not Reconstruct
			transcript.forEach((element) => {
				currentUtt = element;
				currentUtt.Id = currentUtt.Id == Guid_Empty ? GUID() : currentUtt.Id;
				result.push(currentUtt);
			});
		} else {
			// Not Merge, Reconstruct
			let lastUtts: IMeetingUtt[] = [];
			let lastUttsLength = 0;

			const addNewUtt = (utts: IMeetingUtt[]) => {
				if (utts.length == 0) {
					return;
				}

				const firstSrcUtt = utts[0];
				const lastSrcUtt = utts[utts.length-1];

				const newUtt: IMeetingUtt = {};
				newUtt.Id = firstSrcUtt.Id == Guid_Empty ? GUID() : firstSrcUtt.Id;

				newUtt.Text = utts.map(u => u.Text).join(" ");

				newUtt.StartTicks = firstSrcUtt.StartTicks;
				newUtt.DurationTicks = (lastSrcUtt.StartTicks + lastSrcUtt.DurationTicks) - firstSrcUtt.StartTicks;

				newUtt.speaker = {
					id: firstSrcUtt.speaker.id,
					name: firstSrcUtt.speaker.name,
				} as ITranscriptSpeaker;

				result.push(newUtt);
			};

			transcript.forEach(element => {
				if (lastTraversedUtt?.speaker.id != null && element.speaker.id != lastTraversedUtt?.speaker.id) {
					addNewUtt(lastUtts);
					lastUtts = [];
					lastUttsLength = 0;
				}

				lastUtts.push(element);
				lastUttsLength += element.Text.length;

				if (lastUttsLength >= SummeetConfig.maxReconstructedUttLength) {
					addNewUtt(lastUtts);
					lastUtts = [];
					lastUttsLength = 0;
				}

				lastTraversedUtt = element;
			});

			if (lastUtts.length > 0)
			{
				addNewUtt(lastUtts);
			}
		}

	} else {
		// Merge Utts, Reconstruct not appyable
		const AppendResult = () =>
		{
			if (lastTraversedUtt != null) {
				currentUtt.Id = currentUtt.Id == Guid_Empty ? GUID() : currentUtt.Id;
				currentUtt.DurationTicks = (lastTraversedUtt.StartTicks + lastTraversedUtt.DurationTicks) - currentUtt.StartTicks;
				result.push(currentUtt);
			}
		};

		transcript.forEach(element => {
			if (element.speaker.id != lastTraversedUtt?.speaker.id || element.IsSplited)
			{
				AppendResult();
				currentUtt = element;
			}
			else
			{
				const lastOrDefaultChar = currentUtt.Text && currentUtt.Text.length ? currentUtt.Text[currentUtt.Text.length-1] : null;
				if (!punctuationChars.includes(lastOrDefaultChar)) {
					currentUtt.Text += ".";
				}
				currentUtt.Text += " " + element.Text;
			}

			lastTraversedUtt = element;
		});

		AppendResult();
	}
	

	return result;
}

export const  ConvertTranscriptFromApi = (utterances: IMeetingUtt[]): ConvertedDialogueAct[] => {
	const result: ConvertedDialogueAct[] = utterances.map((utt) => {
		const ConvertedDialogueAct: ConvertedDialogueAct = {
			initialData: utt,
			data: {
				id: utt.Id,
				timeEndTicks: utt.StartTicks + utt.DurationTicks,
				startTime: makeShortTimespan(utt.StartTicks),
				time: makeFullTimespan(utt.StartTicks),
				timeTicks: utt.StartTicks,
				name: utt.speaker.name,
				speakerId: utt.speaker.id,
				text: utt.Text,
			},
			isPlaying: false,
			isHighlighted: false,
		};

		return ConvertedDialogueAct;
	});

	return result;
}

export type {ConvertedDialogueAct}